
const config = {
	'sitename'	: 'Digital Venture Dashboard',
	'apiurl'	: '//digitalventure1.com/hrms-api/',
}

export default config;

// //digitalventure1.com/hrms-api/
// http://localhost/hrms-api/


// WEBPACK FOOTER //
// ./src/config.js